<template>
  <div>
    <div class="benefit-desc">
      <div class="benefit-desc-label">权益介绍</div>
      <div class="instruction">
        <div
          :class="{ 'rich-text': true, 'rich-text-more': more }"
          :key="selectSku.item_code"
          v-html="benefitInfo.benefit_instruction"
        ></div>
      </div>
    </div>
    <div class="benefit-desc">
      <div>
        <div class="benefit-desc-label">使用指南</div>
        <div :class="{ 'rich-text': true, 'rich-text-more': more }">
          <van-image
            v-if="selectSku.instruction_img_url"
            :src="selectSku.instruction_img_url"
          />
          <div
            @click="handleUseGuide"
            v-if="selectSku.instruction || selectSku.spu_instruction"
            :key="selectSku.item_code"
            v-replace.day="benefitInfo.coupon_days"
            v-html="selectSku.instruction"
            class="instruction-html"
          ></div>
        </div>
        <a
          v-if="benefitInfo.manual_extra_url"
          class="airport-list"
          :href="benefitInfo.manual_extra_url"
          className="airport-list"
          >{{ benefitInfo.manual_extra_link_name }}</a
        >
      </div>
    </div>
  </div>
</template>

<script>
import copy from "copy-to-clipboard";
import { mapState } from "vuex";

import { jsonSafeParse } from "@/utils";

export default {
  props: {
    benefitInfo: {
      type: Object,
      default: () => ({}),
    },
    selectSku: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      more: false,
    };
  },
  computed: {
    ...mapState(["isMiniProgram"]),
  },
  methods: {
    handleUseGuide(event) {
      const { special_info, product_name } = this.selectSku;
      const target = event.target;
      const linkEl = target.closest("a");
      if (linkEl) {
        // 小程序直接复制链接
        const url = linkEl.getAttribute("href");
        if (this.isMiniProgram && !this.checkUrl(url)) {
          event.preventDefault();
          copy(url);
          this.$toast("使用链接已复制，请打开外部浏览器使用");
        }
        // 获取到a标签上的链接
        if (product_name === "瑞鹏宠物") {
          const url = target.getAttribute("href");
          const template_id = JSON.parse(special_info)?.template_id;
          const handleUrl = `${url}?template_id=${template_id}`;
          target.href = handleUrl;
        }
      }
    },

    checkUrl(url) {
      const MINI_PROGRAM_DOMAIN_WHITE_LIST = jsonSafeParse(
        this.$getConfigValue("MINI_PROGRAM_DOMAIN_WHITE_LIST") || "[]"
      );
      return MINI_PROGRAM_DOMAIN_WHITE_LIST.some((item) => url.includes(item));
    },
  },
};
</script>